import { render, staticRenderFns } from "./PostSections.vue?vue&type=template&id=5403ba0a&scoped=true"
import script from "./PostSections.vue?vue&type=script&lang=js"
export * from "./PostSections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5403ba0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5403ba0a')) {
      api.createRecord('5403ba0a', component.options)
    } else {
      api.reload('5403ba0a', component.options)
    }
    module.hot.accept("./PostSections.vue?vue&type=template&id=5403ba0a&scoped=true", function () {
      api.rerender('5403ba0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSections.vue"
export default component.exports